<template>
  <div>
    <collapse>
      <collapse-item>
        <h3 slot="title" class="mb-0">Campos</h3>

        <ul class="list-group list-group-flush list my--3">
          <li v-for="(field, index) in fields" :key="index" class="list-group-item px-0">
            <div class="row align-items-center">
              <div class="col">
                <h4 v-if="$can('show', 'fields')" class="mb-0">
                  <router-link :to="{ name: 'FieldShow', params: { id: field.id } }">
                    {{ field.name }}
                  </router-link>
                </h4>
                <h4 v-else class="mb-0">{{ field.name }}</h4>
                <small>{{ field.city.name }} - {{ field.city.province.name }}</small>
                <div class="small mt-1"><label>Dirección:&nbsp; </label>{{ field.address }}</div>
              </div>
              <div class="col-auto">
                <router-link
                  v-if="$can('store', 'plots')"
                  :to="{ name: 'PlotCreate', query: { producer: producer, field: field.id } }"
                  class="btn btn-outline-success btn-sm"
                >
                  <i class="fas fa-seedling"></i>&nbsp;Nuevo Lote
                </router-link>
                <router-link
                  v-if="$can('show', 'fields')"
                  :to="{ name: 'FieldShow', params: { id: field.id } }"
                  title="Ver"
                  class="btn base-button btn-outline-info btn-sm"
                >
                  <i class="far fa-eye"></i> VER DETALLES
                </router-link>
              </div>
            </div>
          </li>

          <li v-if="fields.length === 0" class="list-group-item px-0">
            <div class="row align-items-center">
              <div class="col">
                <h4 class="mb-0">Este productor no tiene campos cargados.</h4>
              </div>
            </div>
          </li>
        </ul>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'ProducerFields',
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    producer: null,
  },

  data() {
    return {
      fields: [],
    };
  },

  created() {
    const parameters = {
      include: 'city.province',
      'filter[producer]': this.producer,
    };

    this.$services
      .resource('fields')
      .get(parameters)
      .then((res) => res.data.data)
      .then((data) => (this.fields = data.fields));
  },
};
</script>
